export let baseUrl;

const VERSION = 'api/v1';
baseUrl = `${process.env.REACT_APP_URL}/${VERSION}`;
